var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-contains"},[_c('Head',{class:{ 'scrolled': _vm.isScrolled }}),_c('div',{staticClass:"screen-content"},[_c('ViewMain')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }